import DeclinedStatusActions from '../ModeratingStatusActions/component';

export default DeclinedStatusActions;
